import type { PortalKey } from '@services/access';

/**
 * Profile, notifications and change-password pages of a portal. Admin reuses the user profile path,
 * though the top bar hides that link for the JWT admin.
 */
export function accountPaths(portal: PortalKey): {
  profile: string;
  notifications: string;
  changePassword: string;
} {
  switch (portal) {
    case 'admin':
      return {
        profile: '/user/profile',
        notifications: '/admin/notifications',
        changePassword: '/admin/change-password',
      };
    case 'org':
      return {
        profile: '/org/profile',
        notifications: '/org/notifications',
        changePassword: '/org/change-password',
      };
    case 'user':
      return {
        profile: '/user/profile',
        notifications: '/user/notifications',
        changePassword: '/user/change-password',
      };
  }
}
